import { render } from "./Rss.vue?vue&type=template&id=0cdb2281&scoped=true"
import script from "./Rss.vue?vue&type=script&lang=js"
export * from "./Rss.vue?vue&type=script&lang=js"

import "./Rss.vue?vue&type=style&index=0&id=0cdb2281&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdb2281"]])

export default __exports__